<div bsModal #extensionModal="bs-modal" [config]="{backdrop: 'static',  keyboard: false}" class="modal fade noprint"
  tabindex="-1" role="dialog" aria-labelledby="taxModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Validity Extension</h4>
      </div>
      <div class="modal-body" style="padding-bottom: 20px;">
        <form #extensioninfoForm="ngForm" novalidate>
          <div class="row" style="margin-top:20px;">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="requestedby">Requested By
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Person name who requested extenstion</span>
                <div class="controls">
                  <input type="text" (keypress)="onlyAlphabets($event)" (paste)="onPasteRequestedBy($event)" [(ngModel)]="extensionInfo.requestedBy" #requestedby="ngModel" name="requestedby"
                    id="requestedby" class="form-control" placeholder="Enter requested person name here..." required />
                  <div [hidden]="requestedby.valid || requestedby.pristine" class="danger-text">
                    Requested person name is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="requestdate">Request Date
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Validity extension request date</span>
                <div class="controls">
                  <input type="date"  [(ngModel)]="extensionInfo.requestedDate" #requestdate="ngModel" name="requestdate"
                    id="requestdate" class="form-control" placeholder="Enter request date here..." required />
                  <div [hidden]="requestdate.valid || requestdate.pristine" class="danger-text">
                    Request date is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="clear:both;">
              <div class=" form-group">
                <label class="form-label" for="comments">Comments
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Validity extension comments</span>
                <div class="controls">
                  <input type="text" [(ngModel)]="extensionInfo.comments" #comments="ngModel" name="comments"
                    id="comments" class="form-control" placeholder="Enter validity extension comments here..."
                    required />
                  <div [hidden]="comments.valid || comments.pristine" class="danger-text">
                    Validity extension comment is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class=" form-group">
                <label class="form-label" for="noofdays">No of days to extend
                  <span class="mandatory-symbol">*</span>
                </label>
                <span class="desc">Number of days to extend</span>
                <div class="controls">
                  <input type="number"  (keypress)="onlyNumberKey($event)" (paste)="onPasteDaysNumber($event)" min="1"
                    [(ngModel)]="extensionInfo.validityExt" #noofdays="ngModel" name="noofdays" id="noofdays"
                    class="form-control" placeholder="Enter no of days..." required />
                  <div [hidden]="noofdays.valid || noofdays.pristine" class="danger-text">
                    Validity extension days is required
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="text-center">
          <button type="button" class="btn btn-sm btn-primary" (click)="closeWindow()">Close</button>
          <button type="button" [disabled]="!extensioninfoForm.form.valid" class="btn btn-sm btn-success"
            (click)="updateValidity()">Extend Validity</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #extensionHistoryModal="bs-modal" [config]="{backdrop: 'static',  keyboard: false}"
  class="modal fade noprint" tabindex="-1" role="dialog" aria-labelledby="taxModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Validity Extension History</h4>
      </div>
      <div class="modal-body" style="padding: 20px;max-height: 250px;overflow: scroll;">
        <p-table [value]="subscriptionExtensionHistory" sortMode="multiple"
          [paginator]="subscriptionExtensionHistory!=null && subscriptionExtensionHistory.length>0" [rows]="10" #dt>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 75px;text-align: center;">
                #
              </th>
              <th [pSortableColumn]="'requestedDate'">Request Date
              </th>
              <th [pSortableColumn]="'requestedBy'">Requested By
              </th>
              <th [pSortableColumn]="'comments'">Comments
              </th>
              <th [pSortableColumn]="'validityExt'">Extended Days
              </th>
              <th [pSortableColumn]="'updatedBy'">Updated By
              </th>
              <th [pSortableColumn]="'created'">Updated Time
              </th>
            </tr>
            <tr *ngIf="subscriptionExtensionHistory==null || subscriptionExtensionHistory.length==0"
              style="background: #fff5f3;">
              <td colspan="7">
                <div style="padding: 5px;text-align: center;">
                  No record found
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-history let-i="rowIndex">
            <tr style="cursor: pointer;">
              <td style="text-align: center;">
                {{ i + 1}}
              </td>
              <td>{{history.requestedDate | date:'dd/MMM/yyyy' }}</td>
              <td>
                {{history.requestedBy}}
              </td>
              <td>
                {{history.comments}}
              </td>
              <td>
                {{history.validityExt}}
              </td>
              <td>
                {{history.updatedBy}}
              </td>
              <td>{{history.created | date:'dd/MMM/yyyy hh:mm a'}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="modal-footer">
        <div class="text-center">
          <button type="button" class="btn btn-sm btn-primary" (click)="closeExtensionHistoryWindow()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="box">
  <div class="tile-progress bg-white text-left">
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
        <label>Select Account</label>
        <ng-select [items]="accounts" (change)="getScreeningCentersByAccountID()" name="accounts"
          placeholder="Select account" bindLabel="accountName" [clearable]="true" [searchable]="true" bindValue="accountId"
          [(ngModel)]="accountId">
        </ng-select>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3" *ngIf="accountId!=null && accountId>0">
        <label>Select Screening Center</label>
        <ng-select [items]="screeningCenters" (change)="getPackagesSubscribed()" name="screeingcenters"
          placeholder="Select screening center" bindLabel="orgName" [clearable]="true" [searchable]="true"
          bindValue="orgId" [(ngModel)]="orgId">
        </ng-select>
      </div>
    </div>
  </div>
  <div *ngIf="accountId!=null && accountId>0">
    <div class="card-header" style="border-bottom: none !important;">
      Packages Subscribed
    </div>
    <div class="card-body">
      <div style="background: #FFF;cursor: pointer;padding-bottom: 20px;">
        <ul
          style="list-style-type: none;margin: 0;padding: 0;overflow: hidden;width:100%;border-bottom: 1px solid#cadae2;">
          <li id="1" (click)="filterPackagesByStatus('ALL',1)"
            style="float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none; border-bottom: 1px solid darkgrey;">
            All</li>
          <li id="2" (click)="filterPackagesByStatus('In Use',2)"
            style="float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none; border-bottom: 1px solid darkgrey">
            In Use</li>
          <li id="3" (click)="filterPackagesByStatus('Yet to use',3)"
            style="float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none; border-bottom: 1px solid darkgrey">
            Yet to use</li>
          <li id="4" (click)="filterPackagesByStatus('Quota Exceeded',4)"
            style="float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none; border-bottom: 1px solid darkgrey">
            Quota Exceeded</li>
          <li id="5" (click)="filterPackagesByStatus('Expired',5)"
            style="float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none; border-bottom: 1px solid darkgrey">
            Expired</li>
        </ul>
      </div>
      <p-table
        [value]="packagesSubscribed" [lazy]="true" (onLazyLoad)="onPageChange($event)"
            [paginator]="packagesSubscribed!=null && packagesSubscribed.length>0" [rows]="10" [totalRecords]="totalRecords"  #dt
        >
        <ng-template pTemplate="header" >
          <tr >
            <th style="width: 135px;text-align: center;">
              #
            </th>
            <th [pSortableColumn]="'pkgName'">Package Name
            </th>
            <th style="width:135px;text-align: center;" [pSortableColumn]="'currentStatus'">Status
            </th>
            <th [pSortableColumn]="'price'">Price
            </th>
            <th style="width:100px;" [pSortableColumn]="'quantity'">Qty
            </th>
            <th [pSortableColumn]="'expiry'">Expiry Date
            </th>
            <th [pSortableColumn]="'created'">Purchase Date
            </th>
            <th style="width:200px;" [pSortableColumn]="'createdBy'">Purchased By
            </th>
            <th style="text-align:center;width:120px">Validity
            </th>
          </tr>
          <tr *ngIf="packagesSubscribed==null || packagesSubscribed.length==0" style="background: #fff5f3;">
            <td colspan="9">
              <div style="padding: 5px;text-align: center;">
                No record found
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-package let-i="rowIndex">
          <tr class="table-striped" style="cursor: pointer;">
            <td style="text-align: center;">
              {{ i + 1}}
            </td>
            <td>{{package.pkgName}}</td>
            <td  style="text-align: center;">
              <span   *ngIf="package.currentStatus=='PACKAGE_SUBSCRIBED'"
                style="font-weight:bold;color: rgb(0, 102, 255);">Yet to use</span>
              <span   *ngIf="package.currentStatus=='PACKAGE_IN_USE'"
                style="font-weight:bold;color:green;">In use</span>
              <span  *ngIf="package.currentStatus=='PACKAGE_QUOTA_EXCEEDED'"
                style="font-weight:bold;color: rgb(255,131,0);">Quota Exceeded</span>
              <span *ngIf="package.currentStatus=='PACKAGE_EXPIRED'"
                style="font-weight:bold;color: red;">Expired</span>
              <span class="badge badge-warning" *ngIf="package.currentStatus=='PAYMENT REFUNDED'"
                style="font-weight:bold;color: rgb(0, 225, 255);">Refunded</span>
            </td>
            <td>
              {{package.price | number:'.2'}}
            </td>
            <td>
              {{package.quantity}}
            </td>
            <td>
              <!--{{package.expiry | date:'dd/MMM/yyyy' }}-->
              {{package.expiry | date:customDateFormat }}
            </td>
            <td>
              <!--{{package.created | date:'dd/MMM/yyyy' }}-->
              {{package.created | date:customDateFormat}}
            </td>
            <td>
              {{package.createdBy}}
              <br />
              <span>
                <span style="color: #3e78b6;font-weight: bold;"
                  *ngIf="package.orgId!=null && package.orgId!=''">[Operator]</span>
                <span style="color: #3e78b6;font-weight: bold;"
                  *ngIf="package.orgId==null || package.orgId==''">[Account
                  Admin]</span>
              </span>
            </td>
            <td style="text-align: center;">
              <button (click)="openValidityExtensionWindow(package)" style="margin-right: 5px;margin-left: 5px;background-color: rgb(0,174,65);"
                *ngIf="package.currentStatus=='PACKAGE_SUBSCRIBED' || package.currentStatus=='PACKAGE_IN_USE'"
                class="btn btn-xs btn-success">
                <i class="fa fa-calendar"></i>
              </button>
              <button (click)="getPackageExtensionHistory(package.id)" style="margin-right: 5px;margin-left: 5px;background-color: rgb(255,131,0);"
                class="btn btn-xs btn-warning">
                <i class="fa fa-history"></i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>